import get from 'lodash/get'
import { IShipperRateSourceStatusEnum } from 'types/graphqlTypes'
import { TAG_STYLE } from 'transfix-ui'
import { JOB_STATUS_LABELS, JOB_STATUS_STYLES, TJobStatusLabels, TJobStatusStyles } from '../types'

export function getJobStatusLabel<K extends IShipperRateSourceStatusEnum>(
  status: K | undefined
): TJobStatusLabels[K] {
  if (status) {
    return get(JOB_STATUS_LABELS, status)
  }
  return ''
}

export function getJobStatusTagStyle<K extends IShipperRateSourceStatusEnum>(
  status: K | undefined
): TJobStatusStyles[K] {
  if (status) {
    return get(JOB_STATUS_STYLES, status)
  }
  return TAG_STYLE.info
}
